const enterpriseList = [
    // 2、入网业务首页
    {
        path: "/enterpriseAccess",
        name: "enterpriseAccess",
        component: () =>
            import ("@/views/enterpriseInternet/enterpriseAccess.vue"),
        meta: {
            title: "开发企业入网"
        }

    },
    // 3、入网须知
    {
        path: "/enterpriseNotice",
        name: "enterpriseNotice",
        component: () =>
            import ("@/views/enterpriseInternet/enterpriseNotice.vue"),
        meta: {
            title: "入网须知"
        }

    },
    // 10、变更类型选择
    {
        path: "/changeType",
        name: "changeType",
        component: () =>
            import ("@/views/enterpriseInternet/changeType.vue"),
        meta: {
            title: "变更类型"
        }

    },
    {
        path: "/addEnterprise",
        name: "addEnterprise",
        component: () =>
            import ("@/views/enterpriseInternet/addEnterprise.vue"),
        meta: {
            title: "新增入网"
        }

    },
    // 8、入网变更入口
    {
        path: "/changeEnterprise",
        name: "changeEnterprise",
        component: () =>
            import ("@/views/enterpriseInternet/changeEnterprise.vue"),
        meta: {
            title: "我要变更"
        }

    },

    {
        path: "/editEnterprise",
        name: "editEnterprise",
        component: () =>
            import ("@/views/enterpriseInternet/editEnterprise.vue"),
        meta: {
            title: "入网编辑"
        }

    },
    // 7、入网查看
    {
        path: "/checkEnterprise",
        name: "checkEnterprise",
        component: () =>
            import ("@/views/enterpriseInternet/checkEnterprise.vue"),
        meta: {
            title: "入网查看"
        }

    },
    // 3.1、新入网
    {
        path: "/newAccessInternet",
        name: "newAccessInternet",
        component: () =>
            import ("@/views/enterpriseInternet/newAccessInternet.vue"),
        meta: {
            title: "入网须知"
        }

    },
    // 3.2、变更
    {
        path: "/changeAccessInternet",
        name: "changeAccessInternet",
        component: () =>
            import ("@/views/enterpriseInternet/changeAccessInternet.vue"),
        meta: {
            title: "变更须知"
        }

    },
    {
        path: "/myManagement",
        name: "myManagement",
        component: () =>
            import ("@/views/enterpriseInternet/myManagement.vue"),
        meta: {
            title: "我的办理"
        }

    },
    // 9、入网企业列表
    {
        path: "/enterprisesList",
        name: "enterprisesList",
        component: () =>
            import ("@/views/enterpriseInternet/enterprisesList.vue"),
        meta: {
            title: "入网企业"
        }

    },
    //10.1 编辑企业资质变更
    {
        path: "/qualificationChange",
        name: "qualificationChange",
        component: () =>
            import ("@/views/enterpriseInternet/qualificationChange.vue"),
        meta: {
            title: "资质变更"
        }

    },
    //10.2 编辑营业执照变更
    {
        path: "/licenseChange",
        name: "licenseChange",
        component: () =>
            import ("@/views/enterpriseInternet/licenseChange.vue"),
        meta: {
            title: "营业执照变更"
        }
    },
    //10.3 编辑固话区域变更
    {
        path: "/areaChange",
        name: "areaChange",
        component: () =>
            import ("@/views/enterpriseInternet/areaChange.vue"),
        meta: {
            title: "固话或区域变更"
        }
    },
    //11.1 查看企业资质
    {
        path: "/checkQualificationChange",
        name: "checkQualificationChange",
        component: () =>
            import ("@/views/enterpriseInternet/checkQualificationChange.vue"),
        meta: {
            title: "查看企业资质"
        }
    },
    //11.2 查看营业执照
    {
        path: "/checkLicenseChange",
        name: "checkLicenseChange",
        component: () =>
            import ("@/views/enterpriseInternet/checkLicenseChange.vue"),
        meta: {
            title: "查看营业执照"
        }
    },

    //11.3 查看固话区域变更
    {
        path: "/checkAreaChange",
        name: "checkAreaChange",
        component: () =>
            import ("@/views/enterpriseInternet/checkAreaChange.vue"),
        meta: {
            title: "查看固话或区域变更"
        }
    }
];
export default enterpriseList;